/** OTP UX policy - mirrors the backend OTP policy where noted. */
export const OTP_UI = {
  /** Digits in a one-time code (backend OTP.LENGTH). */
  CODE_LENGTH: 6,
  /** Code lifetime shown in the countdown (backend OTP.TTL_MINUTES). */
  CODE_TTL_SECONDS: 10 * 60,
  /**
   * Resend unlocks after this cooldown (not the full code TTL) so a user whose
   * email never arrived is not stuck for 10 minutes.
   */
  RESEND_COOLDOWN_SECONDS: 60,
} as const;
